import { CheckBox, Image, TextFields, ArrowDropDownCircle } from '@mui/icons-material';

export const CriteriaTypeDetailTypeEnumValue = {
  Photo: 1,
  Checkbox: 2,
  Input: 3,
  Dropdown: 4,
};

// Array format for iteration (e.g., mapping over types in dropdowns)
const criteriaTypeDetailTypeArray = [
  {
    value: CriteriaTypeDetailTypeEnumValue.Photo,
    name: 'Photo',
    labelFrench: 'Photo',
    labelEnglish: 'Photo',
    icon: Image,
    iconColor: '#2196F3',
  },
  {
    value: CriteriaTypeDetailTypeEnumValue.Checkbox,
    name: 'Checkbox',
    labelFrench: 'Case à cocher',
    labelEnglish: 'Checkbox',
    icon: CheckBox,
    iconColor: '#66BB6A',
  },
  {
    value: CriteriaTypeDetailTypeEnumValue.Input,
    name: 'Input',
    labelFrench: 'Entrée',
    labelEnglish: 'Input',
    icon: TextFields,
    iconColor: '#FF9800',
  },
  {
    value: CriteriaTypeDetailTypeEnumValue.Dropdown,
    name: 'Select',
    labelFrench: 'Sélection',
    labelEnglish: 'Select',
    icon: ArrowDropDownCircle,
    iconColor: '#8E24AA',
  },
];

// Create indexed object for direct access by value
// Usage: CriteriaTypeDetailTypeEnum[CriteriaTypeDetailTypeEnumValue.Photo]
const CriteriaTypeDetailTypeEnum = {};
criteriaTypeDetailTypeArray.forEach(type => {
  CriteriaTypeDetailTypeEnum[type.value] = type;
});

// Add array as property for iteration
// Usage: CriteriaTypeDetailTypeEnum.array.map(...)
CriteriaTypeDetailTypeEnum.array = criteriaTypeDetailTypeArray;

/**
 * Get label for CriteriaTypeDetailType (deprecated - use CriteriaTypeDetailTypeEnum[value] instead)
 * @param {number} type - The type value
 * @returns {string} The label
 * @deprecated Use CriteriaTypeDetailTypeEnum[type].labelEnglish or translateEnum(CriteriaTypeDetailTypeEnum[type])
 */
export const getCriteriaTypeDetailTypeLabel = type => {
  const typeObj = CriteriaTypeDetailTypeEnum[type];
  return typeObj?.labelEnglish || 'Unknown';
};

export { CriteriaTypeDetailTypeEnum };
export default CriteriaTypeDetailTypeEnum;
